import {
	getArrayOfFilterableBusinessUnits,
	getArrayOfFilterableServices,
} from '@tracsis/library/lib/helpers';
import { Button } from '@tracsis/library/src';
import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import React, { useContext } from 'react';

import { Search as SearchIcon } from '../Icon';
import * as styles from './Search.module.css';

const Search = ({
	siteName,
	action,
	label,
	searchQuery,
	hasFilter,
	filterQuery,
}: {
	siteName?: string;
	action: string;
	label: string;
	searchQuery: string | undefined;
	hasFilter?: boolean;
	filterQuery: string | undefined;
}) => {
	const { variant } = useContext(ThemeContext);
	return (
		<form
			action={action}
			method="get"
			autoComplete="off"
			className={styles.form}
		>
			<div className={styles.field}>
				<label htmlFor="search" className={styles.label}>
					Search {siteName} {label}
				</label>
				<input
					type="text"
					name="s"
					id="search"
					aria-label="Search"
					placeholder="..."
					defaultValue={searchQuery}
					className={cx(styles.input, styles[variant])}
				/>
			</div>

			{hasFilter && (
				<>
					{/* <div className={cx(styles.field, styles.fieldSmall)}>
						<label htmlFor="service" className={styles.label}>
							Filter by Business Unit
						</label>
						<select
							name="business-unit"
							id="businessunit"
							aria-label="Business Units"
							className={styles.input}
							defaultValue={filterQuery}
						>
							<option value="all" defaultValue>
								All Business Units
							</option>
							{getArrayOfFilterableBusinessUnits().map((unit, i) => (
								<option key={i} value={unit.value}>
									{unit.label}
								</option>
							))}
						</select>
					</div> */}

					<div className={cx(styles.field, styles.fieldSmall)}>
						<label htmlFor="service" className={styles.label}>
							Filter by Services
						</label>
						<select
							name="service"
							id="service"
							aria-label="Services"
							className={styles.input}
							defaultValue={filterQuery}
						>
							<option value="all" defaultValue>
								All Services
							</option>
							{getArrayOfFilterableServices().map((service, i) => (
								<option key={i} value={service.value}>
									{service.label}
								</option>
							))}
						</select>
					</div>
				</>
			)}

			<Button type="submit" aria-label="Submit query" className={styles.button}>
				Search
				<SearchIcon />
			</Button>
		</form>
	);
};

export default Search;
